/* eslint-disable newline-after-var */

// IE Symbol Polyfill

require('core-js/fn/symbol');
require('core-js/fn/symbol/iterator');

// IE Array polyfill
require('core-js/fn/array/from');

// IE Number polyfill
require('core-js/fn/number/is-integer');

import initAccordion from './components/Accordion';
import initAlert from './components/Alert';
import initModal from './components/Modal';
import initNav from './components/Nav';
import initSearch from './components/Search';
import initTable from './components/tables/Table';
import initTabs from './components/Tabs';
import initTooltip from './components/Tooltip';
import initPagination from './components/Pagination';
import initLoader from './components/Loader';
import initDropdown from './components/Dropdowns';
import initBackToTop from './components/BackToTop';
import initDrawer from './components/Drawer';
import initFilter from './components/Filter';
import initCountdownTimer from './components/CountdownTimer';
import initPriceTick from './components/PriceTick';
import initButtonGroup from './components/ButtonGroup';
import initToasts from './components/Toasts';
import initSplitPanel from './components/SplitPanel';
import initDatepicker from './components/Datepicker';

const commonUI = (() => {
  /**
   * initialize the dropdowns per selector
   * @param  {Object} config
   */
  const initializeDropdown = (config) =>
    initDropdown(config);
  /**
   * initialize the tabs per selector
   * @param  {Object} config
   */
  const initializeTabs = (config) =>
    initTabs(config);
  /**
   * Initialize the modal
   * @param  {Object} config
   */
  const initializeModal = (config) =>
    initModal(config);
  /**
   * Creates a new alert instance
   * @param  {Object} config
   */
  const initializeAlert = (config) =>
    initAlert(config);
  /**
     * Initialize the table
     * @param  {Object} config
     */
  const initializeTable = (config) =>
    initTable(config);
  /**
     * Initialize the nav
     * @param  {Object} config
     */
  const initializeNavigation = (config) =>
    initNav(config);
  /**
   * Initialize the search
   * @param  {Object} config
   */
  const initializeSearch = (config) =>
    initSearch(config);
  /**
     * Initialize the accordion
     * @param  {Object} config
     */
  const initializeAccordion = (config) =>
    initAccordion(config);
  /**
     * Initialize the tooltip
     * @param  {Object} config
     */
  const initializeTooltip = (config) =>
    initTooltip(config);
  /**
     * Initialize the pagination
     * @param  {Object} config
     */
  const initializePagination = (config) =>
    initPagination(config);

  /**
     * Initialize the loader
     * @param  {Object} config
     */
  const initializeLoader = (config) =>
    initLoader(config);

  /**
     * Initialize the back to top
     * @param  {Object} config
     */
  const initializeBackToTop = (config) =>
    initBackToTop(config);

  /**
     * Initialize the drawer
     * @param  {Object} config
     */
  const initializeDrawer = (selector, config) =>
    initDrawer(selector, config);

    /**
     * Initialize the filter
     * @param  {Object} config
     */
  const initializeFilter = (selector, config) =>
    initFilter(selector, config);

    /**
     * Initialize the countdown timer
     * @param  {Object} config
     */
  const initializeCountdownTimer = (selector, config) =>
    initCountdownTimer(selector, config);

    /**
     * Initialize the price ticker
     * @param  {Object} config
     */
  const initializePriceTick = (selector, config) =>
    initPriceTick(selector, config);

    /**
     * Initialize the button group
     * @param  {Object} config
     */
  const initializeButtonGroup = (config) =>
    initButtonGroup(config);

    /**
     * Initialize the toasts
     * @param  {Object} config
     */
  const initializeToasts = (config) =>
    initToasts(config);

    /**
     * Initialize the split panel
     * @param  {Object} config
     */
  const initializeSplitPanel = (config) =>
  initSplitPanel(config);

  const initializeDatepicker = (element, config) =>
    initDatepicker(element, config);

  /**
   * Reveal public pointers
   */
  return {
    initializeDropdown,
    initializeTabs,
    initializeModal,
    initializeAlert,
    initializeTable,
    initializeNavigation,
    initializeSearch,
    initializeAccordion,
    initializeTooltip,
    initializePagination,
    initializeLoader,
    initializeBackToTop,
    initializeDrawer,
    initializeFilter,
    initializeCountdownTimer,
    initializePriceTick,
    initializeButtonGroup,
    initializeToasts,
    initializeSplitPanel,
    initializeDatepicker,
  };
})();

module.exports = commonUI;



// WEBPACK FOOTER //
// ./js/commonUI.js